/** Nhãn tiếng Việt cho luồng "đưa QR vào ảnh của bạn" — theo docs/50-smart-placement.md §3/§8
 * và docs/71-consumer-ux.md §7 (chỉ hiện chữ, không hiện số/mã lỗi kỹ thuật).
 *
 * `scanabilityToDisplay` ở dưới là mapping 3-mức CHUẨN theo §7 cho MỌI nơi hiển thị kết quả
 * `@qrstudio/scanability` thật của server (không chỉ luồng ảnh) — cũng được tái dùng trực
 * tiếp ở màn Kết quả (`components/ResultStep.tsx`) và chế độ Nâng cao
 * (`editor/scanability.ts`, hàm `resolveScanDisplay`), để toàn app dùng chung MỘT bộ nhãn
 * tiếng Việt, không lệch nhau. */

const SURFACE_KIND_LABEL: Record<string, string> = {
  phone_screen: "Màn hình điện thoại",
  tablet_screen: "Màn hình máy tính bảng",
  laptop_screen: "Màn hình laptop",
  monitor: "Màn hình máy tính",
  pos_terminal: "Máy POS",
  paper_sheet: "Tờ giấy",
  card: "Card visit",
  poster: "Poster",
  menu: "Menu",
  flyer: "Tờ rơi",
  sign_board: "Bảng hiệu",
  standee: "Standee",
  billboard: "Biển quảng cáo",
  tshirt: "Áo",
  mug: "Cốc/ly",
  box_face: "Mặt hộp sản phẩm",
  wall_empty: "Mảng tường trống",
  table_surface: "Mặt bàn",
  held_object: "Vật cầm tay",
  generic_planar: "Bề mặt phẳng",
};

/** Nhãn hiển thị cho một ứng viên đặt QR — ưu tiên reasons[0] (đã là tiếng Việt từ server),
 * fallback theo surfaceKind, cuối cùng là nhãn chung chung. */
export function candidateLabel(reasons: string[], surfaceKind: string): string {
  const first = reasons[0];
  if (first) return first;
  return SURFACE_KIND_LABEL[surfaceKind] ?? "Vị trí gợi ý";
}

/** Điểm số → chỉ báo chất lượng dạng chữ, không hiện số thô. */
export function scoreToQualityLabel(score: number): { text: string; tone: "good" | "ok" | "warn" } {
  if (score >= 80) return { text: "Rất tốt", tone: "good" };
  if (score >= 55) return { text: "Được", tone: "ok" };
  return { text: "Hơi khó quét", tone: "warn" };
}

export type ScanabilityDisplay = {
  tone: "good" | "warn" | "bad";
  title: string;
  showRepairAction: boolean;
};

/** Ba trạng thái theo docs/71-consumer-ux.md §7 — không bao giờ hiện điểm số/mã check kỹ thuật. */
export function scanabilityToDisplay(label: string, bankingSafe: boolean): ScanabilityDisplay {
  const upper = label.toUpperCase();
  if (upper === "BANKING_SAFE" || upper === "GOOD" || bankingSafe) {
    return { tone: "good", title: "Mã quét tốt", showRepairAction: false };
  }
  if (upper === "UNSAFE") {
    return { tone: "bad", title: "Mã này không quét được", showRepairAction: false };
  }
  // RISKY hoặc nhãn lạ chưa biết — xử lý an toàn theo hướng cảnh báo, không coi là quét tốt.
  return { tone: "warn", title: "Mã hơi khó quét", showRepairAction: true };
}
